/*
  Diorin — mangalsutra reward bar motion (bar markup: snippets/diorin-bogo.liquid, part 'nudge').

  The cart drawer is re-rendered as fresh HTML on every change, so CSS alone can't
  animate between states. This remembers the last fill % and saving (sessionStorage),
  grows the fill from the old width to the new one, and plays a cash burst + toast
  when the saving goes up (a new bundle tier was unlocked).
*/
(function () {
  var KEY = 'diorinRewardBar';
  var BITS = ['💸', '💰', '💵', '🎉', '✨', '🪙'];
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function read() {
    try {
      return JSON.parse(sessionStorage.getItem(KEY));
    } catch (e) {
      return null;
    }
  }
  function write(v) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify(v));
    } catch (e) {}
  }
  function rupees(paise) {
    return '₹' + Math.round(paise / 100).toLocaleString('en-IN');
  }

  function celebrate(bar, saved) {
    var r = bar.getBoundingClientRect();
    if (!r.width) return; // drawer closed / bar hidden
    var layer = document.createElement('div');
    layer.setAttribute('aria-hidden', 'true');
    layer.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:2147483000;overflow:hidden;';
    document.body.appendChild(layer);

    var toast = document.createElement('div');
    toast.textContent = '🎉 Offer unlocked! You save ' + rupees(saved);
    toast.style.cssText =
      'position:absolute;left:' + (r.left + r.width / 2) + 'px;top:' + Math.max(8, r.top - 6) + 'px;' +
      'transform:translate(-50%,-100%);padding:7px 14px;border-radius:999px;background:#2e7d32;color:#fff;' +
      'font:700 13px/1.2 var(--font-body-family, sans-serif);white-space:nowrap;box-shadow:0 6px 18px rgba(46,125,50,.35);';
    layer.appendChild(toast);
    toast.animate(
      [
        { opacity: 0, transform: 'translate(-50%,-60%) scale(.8)' },
        { opacity: 1, transform: 'translate(-50%,-100%) scale(1.05)', offset: 0.15 },
        { opacity: 1, transform: 'translate(-50%,-100%) scale(1)', offset: 0.85 },
        { opacity: 0, transform: 'translate(-50%,-130%) scale(1)' },
      ],
      { duration: 2400, easing: 'ease-out', fill: 'forwards' }
    );

    if (!reduceMotion) {
      for (var i = 0; i < 26; i++) {
        var s = document.createElement('span');
        s.textContent = BITS[i % BITS.length];
        var x = r.left + Math.random() * r.width;
        var y = r.top + r.height / 2;
        s.style.cssText = 'position:absolute;left:' + x + 'px;top:' + y + 'px;font-size:' + (16 + Math.random() * 12) + 'px;';
        layer.appendChild(s);
        var dx = (Math.random() - 0.5) * 220;
        var up = 90 + Math.random() * 160;
        s.animate(
          [
            { transform: 'translate(0,0) rotate(0deg) scale(.6)', opacity: 1 },
            { transform: 'translate(' + dx * 0.6 + 'px,' + -up + 'px) rotate(' + dx + 'deg) scale(1.1)', opacity: 1, offset: 0.45 },
            { transform: 'translate(' + dx + 'px,' + (-up + 140) + 'px) rotate(' + dx * 2 + 'deg) scale(1)', opacity: 0 },
          ],
          { duration: 1300 + Math.random() * 600, delay: Math.random() * 180, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'forwards' }
        );
      }
    }
    setTimeout(function () {
      layer.remove();
    }, 2600);
  }

  function sync() {
    var bars = document.querySelectorAll('.diorin-rb:not([data-rb-seen])');
    var anyBar = document.querySelector('.diorin-rb');
    var prev = read();
    if (!anyBar) {
      // No mangalsutra in the bag any more: start from zero next time.
      if (prev && prev.saved) write({ saved: 0, pct: 0 });
      return;
    }
    if (!bars.length) return;

    var now = null;
    bars.forEach(function (bar) {
      bar.setAttribute('data-rb-seen', '');
      now = { saved: +bar.dataset.saved || 0, pct: +bar.dataset.pct || 0 };
      var fill = bar.querySelector('.diorin-rb__fill');
      if (fill && prev && prev.pct !== now.pct) {
        fill.style.transition = 'none';
        fill.style.width = prev.pct + '%';
        void fill.offsetWidth; // commit the start width before animating
        fill.style.transition = '';
        fill.style.width = now.pct + '%';
      }
      if (prev && now.saved > prev.saved) {
        // let the drawer finish sliding in before measuring where the bar is
        setTimeout(celebrate, 450, bar, now.saved);
      }
    });
    write(now);
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      sync();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
  sync();
})();
